import { useLocation } from 'react-router-dom';

import { routes } from '../constants/routes';

export const useIsPublicRoute = () => {
  const { pathname } = useLocation();

  return pathname === routes.login || pathname === routes.loginCallback;
};
